import moment from "moment";
import CategoryService from "@/services/category.service";
import SubCategoryService from "@/services/subcategory.service";
import BrandService from "@/services/brand.service";
import ModelService from "@/services/model.service";
import GarageService from "@/services/garage.service";
import BranchService from "@/services/branch.service";
import SupplierService from "@/services/supplier.service";
import FeatureService from "@/services/feature.service";
import LicenseTypeService from "@/services/licenseType.service";
import LanguageService from "@/services/language.service";
import NationalityService from "@/services/nationality.service";
import DriverService from "@/services/driver.service";
import CityService from "@/services/city.service";
import DamageLevelService from "@/services/damage-level.service";
import companyProfile from "@/services/companyProfile.service";
import TrainingTypeService from "@/services/training-type.service";
import VehicleTypeService from "@/services/vehicle-type.service";
import ProductService from "@/services/product.service";
import TGATypeService from "@/services/tga-type.service";
import ReligionService from "@/services/religion.service";
import ServiceCategory from "@/services/service-category.service";
import TemporaryResourcesRequestService from "@/services/temporary-resources-request.service";
import UserService from "@/services/user.service";
import TripService from "@/services/trip.service";
import ClientCityService from "@/services/client-city.service";
import ClientCountryService from "@/services/client-country.service";
import ShiftService from "@/services/shift.service";
import PricingListService from "@/services/pricing-list.service";
import HajjSeasonYearService from "@/services/hajj-season-year.service";
import ContractService from "@/services/contract.service";
import ContractRouteService from "@/services/contract-route.service";

import {
  SET_APP_LANG,
  GET_ADMINS_ENUMS,
  GET_ROLES_ENUMS,
  GET_CATEGORY_ENUMS,
  GET_SUB_CATEGORY_ENUMS,
  GET_COLOR_ENUMS,
  GET_YEAR_ENUMS,
  GET_BRAND_ENUMS,
  GET_MODEL_ENUMS,
  GET_GARAGE_ENUMS,
  GET_HAJJ_GARAGE_ENUMS,
  GET_BRANCH_ENUMS,
  GET_PROVIDER_ENUMS,
  GET_FEATURES_ENUMS,
  GET_LICENSE_TYPE_ENUMS,
  GET_LANGUAGE_ENUMS,
  GET_NATIONALITY_ENUMS,
  GET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS,
  GET_DRIVER_LIST_ENUMS,
  GET_SERVICE_TYPE_ENUMS,
  GET_CLIENT_ENUMS,
  GET_CITY_ENUMS,
  GET_DAMAGE_LEVEL_ENUMS,
  GET_DAMAGE_AREA_ENUMS,
  GET_BODY_DAMAGE_AREA_ENUMS,
  GET_USER_INFO,
  GET_CLIENT_INFO,
  GET_ACTIVE_ROLES_ENUMS,
  GET_COMPANIES_ENUMS,
  GET_MISSING_PART_ITEMS,
  GET_INSURANCE_COMPANY_ENUMS,
  GET_REGIONS_ENUMS,
  GET_PROVINCES_ENUMS,
  GET_ZONE_ENUMS,
  GET_POS_ENUMS,
  GET_MOBILE_ENUMS,
  GET_SERVICES_ENUMS,
  GET_DRIVER_AVAILABILITY,
  GET_VEHICLE_AVAILABILITY,
  GET_PROMO_CODE_ENUMS,
  GET_LTA_LIST_ENUMS,
  GET_CLIENT_TYPE_ENUMS,
  GET_ACCOUNT_ENUMS,
  GET_PROFORMA_INVOICE_ENUMS,
  GET_JV_ENUMS,
  GET_RESERVATION_LIST_ENUMS,
  GET_REMOTE_FINANCE_ACCOUNT_ENUMS,
  GET_TAX_TYPE_ENUMS,
  GET_TAX_TYPE_ZOHO_ENUMS,
  GET_OPERATOR,
  GET_TRAINING_TYPES_ENUMS,
  GET_TAX_TYPE_ODOO_ENUMS,
  GET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS,
  GET_PRODUCT_ENUMS,
  GET_PRICING_LISTS_ENUMS,
  GET_HAJJ_SEASON_YEAR_ENUMS,
  GET_TGA_TYPES_ENUMS,
  GET_RELIGION_ENUMS,
  GET_CLIENT_GRADE_ENUMS,
  GET_RESERVATION_CATEGORY_ENUMS,
  GET_SERVICE_CATEGORY_ENUMS,
  GET_CONTRACT_TYPE_ENUMS,
  GET_DRIVER_USERNAME_ENUMS,
  GET_CLIENT_USERNAME_ENUMS,
  GET_RESOURCE_REQUEST_USERNAME_ENUMS,
  GET_USER_ENUMS,
  GET_RESERVATION_FILE,
  GET_TRIPS_FILE,
  SET_MISSING_REQUEST_PAYLOAD_IN_STORE,
  GET_VEHICLE_TYPE_ENUMS,
  GET_BLANKET_ORDER_ENUMS,
  GET_KPI_REASON_ENUMS,
  GET_CLIENT_CITY_ENUMS,
  GET_CLIENT_COUNTRY_ENUMS,
  GET_MODEL_INCLUDED_ENUMS,
  SHOW_TOASTER_POP,
  GET_AVAILABLE_RESERVATION_LIST_ENUMS,
  GET_CHANGE_PASSWORD_TOKEN,
  GET_SHIFT_TYPE_ENUMS,
  GET_DRIVER_EMPLOYEE_ID_ENUMS,
  GET_CONTRACT_ID_ENUMS,
  GET_CONTRACT_ID_CLIENT_ENUMS,
  GET_PAYMENT_TYPES_ENUMS,
  GET_CLIENT_CONTACT_PERSON_ENUMS,
  GET_ENTITY_ENUMS,
  GET_USERNAME_ENUMS,
  GET_ADMIN_CONFIGURATION_ENUMS,
  GET_DRIVER_ALLOWANCE_FILE,
  GET_HAJJ_DAWRA_OPERATIONS_FILE,
  GET_DRIVER_EMP_ID_ENUMS,
  GET_PRICING_LIST_FILE,
  GET_ROUTES_LIST_ENUMS,
  GET_TRIPS_CONTRACT_FILE,
  GET_WORKFLOW_ENUMS,
  GET_PROFORMA_INVOICE_NUMBER_ENUMS,
  GET_USER_NAME_ENUMS
} from "./actions.type";
import {
  SET_LANG,
  SET_CATEGORY_ENUMS,
  SET_SUB_CATEGORY_ENUMS,
  SET_COLOR_ENUMS,
  SET_YEAR_ENUMS,
  SET_BRAND_ENUMS,
  SET_MODEL_ENUMS,
  SET_GARAGE_ENUMS,
  SET_HAJJ_GARAGE_ENUMS,
  SET_BRANCH_ENUMS,
  SET_PROVIDER_ENUMS,
  SET_FEATURES_ENUMS,
  SET_LICENSE_TYPE_ENUMS,
  SET_LANGUAGE_ENUMS,
  SET_NATIONALITY_ENUMS,
  SET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS,
  SET_DRIVER_LIST_ENUMS,
  SET_ROLES_ENUMS,
  SET_ADMINS_ENUMS,
  SET_SERVICE_TYPE_ENUMS,
  SET_CLIENT_ENUMS,
  SET_CITY_ENUMS,
  SET_DAMAGE_LEVEL_ENUMS,
  SET_DAMAGE_AREA_ENUMS,
  SET_BODY_DAMAGE_AREA_ENUMS,
  SET_ACTIVE_ROLES_ENUMS,
  SET_USER_INFO,
  SET_CLIENT_INFO,
  SET_MISSING_PART_ITEMS,
  SET_COMPANIES_ENUMS,
  SET_INSURANCE_COMPANY_ENUMS,
  SET_REGIONS_ENUMS,
  SET_PROVINCES_ENUMS,
  SET_ZONE_ENUMS,
  SET_POS_ENUMS,
  SET_MOBILE_ENUMS,
  SET_SERVICES_ENUMS,
  SET_DRIVER_AVAILABILITY,
  SET_VEHICLE_AVAILABILITY,
  SET_PROMO_CODE_ENUMS,
  SET_LTA_LIST_ENUMS,
  SET_CLIENT_TYPE_ENUMS,
  SET_ACCOUNT_ENUMS,
  SET_PROFORMA_INVOICE_ENUMS,
  SET_JV_ENUMS,
  SET_RESERVATION_LIST_ENUMS,
  SET_REMOTE_FINANCE_ACCOUNT_ENUMS,
  SET_TAX_TYPE_ENUMS,
  SET_TAX_TYPE_ZOHO_ENUMS,
  SET_OPERATOR,
  SET_TRAINING_TYPES_ENUMS,
  SET_TAX_TYPE_ODOO_ENUMS,
  SET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS,
  SET_PRODUCT_ENUMS,
  SET_PRICING_LISTS_ENUMS,
  SET_HAJJ_SEASON_YEAR_ENUMS,
  SET_TGA_TYPES_ENUMS,
  SET_RELIGION_ENUMS,
  SET_CLIENT_GRADE_ENUMS,
  SET_RESERVATION_CATEGORY_ENUMS,
  SET_SERVICE_CATEGORY_ENUMS,
  SET_CONTRACT_TYPE_ENUMS,
  SET_DRIVER_USERNAME_ENUMS,
  SET_CLIENT_USERNAME_ENUMS,
  SET_RESOURCE_REQUEST_USERNAME_ENUMS,
  SET_USER_ENUMS,
  SET_MISSING_REQUEST_PAYLOAD,
  SET_VEHICLE_TYPE_ENUMS,
  SET_BLANKET_ORDER_ENUMS,
  SET_KPI_REASON_ENUMS,
  SET_CLIENT_CITY_ENUMS,
  SET_CLIENT_COUNTRY_ENUMS,
  SET_MODEL_INCLUDED_ENUMS,
  SET_TOASTER_POP,
  SET_AVAILABLE_RESERVATION_LIST_ENUMS,
  SET_CHANGE_PASSWORD_TOKEN,
  SET_SHIFT_TYPE_ENUMS,
  SET_DRIVER_EMPLOYEE_ID,
  SET_CONTRACT_ID_ENUMS,
  SET_CONTRACT_ID_CLIENT_ENUMS,
  SET_PAYMENT_TYPES,
  SET_CLIENT_CONTACT_PERSON_ENUMS,
  SET_ENTITY_ENUMS,
  SET_USERNAME_ENUMS,
  SET_ADMIN_CONFIGURATION_ENUMS,
  SET_DRIVER_EMP_ID_ENUMS,
  SET_ROUTES_ENUMS,
  SET_WORKFLOW_ENUMS,
  SET_PROFORMA_INVOICE_NUMBER_ENUMS,
  SET_USER_NAME_ENUMS
} from "./mutations.type";
import {
  color_enums,
  damage_area_enums,
  body_damage_area_enums,
  clientType_enums,
  contractType_enums,
  countries,
} from "@/lib/helpers";
import ClientService from "@/services/client.service";
import VehicleOperationsService from "@/services/vehicleOperations.service";
import RolesService from "@/services/roles.service";
import InsuranceCompanyService from "@/services/insurance-companies.service";
import RegionService from "@/services/region.service";
import ProvinceService from "@/services/province.service";
import ZoneService from "@/services/zone.service";
import POSDeviceService from "@/services/pos-device.service";
import MobileDeviceService from "@/services/mobile-device.service";
import ServiceService from "@/services/service.service";
import VehicleService from "@/services/vehicle.service";
import PromoCodeService from "@/services/promo-code.service";
import LongTermsAgreementService from "@/services/long-term-agreement.service";
import AccountService from "@/services/account.service";
import ProformaInvoiceService from "@/services/proforma-invoice.service";
import JVService from "@/services/JV.service";
import NewReservationService from "@/services/new-reservation.service";
import TaxTypeService from "@/services/tax-type.service";
import ClientGradeService from "@/services/client-grade.service";
import ReservationCategoryService from "@/services/reservation-category.service";
import BlanketOrderService from "@/services/blanket-order.service";
import DriverAllowanceService from "@/services/driver-allowance.service";
import HajjDawraOperationService from "@/services/hajj-dawra-operation.service";

import store from "@/store";
import PaymentMethodService from "@/services/payment-method.service";
import HistoryService from "@/services/history.service";
import AdminConfigurationService from "@/services/admin-configuration.service";
import WorkFlowService from "@/services/workFlow.service";

export default {
  [SET_APP_LANG]({ commit }, payload) {
    return new Promise((resolve) => {
      commit(SET_LANG, payload);
      resolve(payload);
    });
  },
  [GET_COLOR_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedColors = store.getters["enums/color_enums"];

    if (!forceFetch && cachedColors?.length > 1) {
      return Promise.resolve(cachedColors);
    } 

    return new Promise((resolve) => {
      commit(SET_COLOR_ENUMS, color_enums);
      resolve(color_enums);
    });
  },
  [GET_YEAR_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedYears = store.getters["enums/year_enums"];

    if (!forceFetch && cachedYears?.length > 1) {
      return Promise.resolve(cachedYears);
    } 

    return new Promise((resolve) => {
      let temp = [];
      temp.push({ value: null, text: "select-an-option" });
      for (let i = new Date().getUTCFullYear(); i >= 1980; i--) {
        temp.push({ value: i, text: i });
      }
      commit(SET_YEAR_ENUMS, temp);
      resolve(temp);
    });
  },
  [GET_CATEGORY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedCategory = store.getters["enums/category_enums"];

    if (!forceFetch && cachedCategory?.length > 1) {
      return Promise.resolve(cachedCategory);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      CategoryService.search({ active: true, select: "id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_CATEGORY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CATEGORY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_SUB_CATEGORY_ENUMS]({ commit }, selectedCategory) {
    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let params = {
        active: true,
        select: "_id,name,arabicName,categoryId",
      };

      if (selectedCategory) params["category"] = selectedCategory;

      SubCategoryService.search(params)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              categoryId: each.categoryId,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_SUB_CATEGORY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_SUB_CATEGORY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_BRAND_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedBrand = store.getters["enums/brand_enums"];

    if (!forceFetch && cachedBrand?.length > 1) {
      return Promise.resolve(cachedBrand);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      BrandService.search({ active: true, select: "_id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_BRAND_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_BRAND_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_MODEL_ENUMS]({ commit }, selectedBrand) {
    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let params = {
        active: true,
        select: "_id,name,arabicName,make,yearOfMake",
      };
      if (selectedBrand) params["make"] = selectedBrand;

      ModelService.search(params)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              make: each.make,
              yearOfMake: each.yearOfMake,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_MODEL_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_MODEL_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_MODEL_INCLUDED_ENUMS]({ commit }, selectedBrand = []) {
    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let params = {
        active: true,
        select: "_id,name,arabicName,make,yearOfMake,numberOfSeats",
      };
      if (selectedBrand.length) {
        params["make"] = `in:[${selectedBrand
          .map((each) => each.value)
          .join(",")}]`;
      }
      ModelService.search(params)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              make: each.make,
              yearOfMake: each.yearOfMake,
              numberOfSeats: each.numberOfSeats,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_MODEL_INCLUDED_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_MODEL_INCLUDED_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_GARAGE_ENUMS]({ commit }) {
    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      GarageService.search({ active: true, select: "_id,name,arabicName" })
        .then(({ items }) => {
          const temp = (items || []).map((each) => ({
            value: each._id,
            text: isLangRtl ? each.arabicName : each.name || "",
          }));
          temp.unshift({ value: null, text: temp.length ? "select-an-option" : "no-options-available" });
          commit(SET_GARAGE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_GARAGE_ENUMS, [{ value: null, text: "no-options-available" }]);
          reject(error);
        });
    });
  },
  [GET_HAJJ_GARAGE_ENUMS]({ commit }, selectedBranch) {
    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      const toEnums = (items) => {
        const temp = (items || []).map((each) => ({
          value: each._id,
          text: isLangRtl ? each.arabicName : each.name || "",
        }));
        temp.unshift({ value: null, text: temp.length ? "select-an-option" : "no-options-available" });
        return temp;
      };
      const fetchAll = () =>
        GarageService.search({ active: true, select: "_id,name,arabicName" });
      const fetchByBranch = (branchId) =>
        BranchService.get(`${branchId}/garages`, { active: true, select: "_id,name,arabicName" });

      const promise = selectedBranch
        ? fetchByBranch(selectedBranch)
            .then(({ items }) =>
              items && items.length ? { items } : fetchAll()
            )
        : fetchAll();

      promise
        .then(({ items }) => {
          const temp = toEnums(items);
          commit(SET_HAJJ_GARAGE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_HAJJ_GARAGE_ENUMS, [{ value: null, text: "no-options-available" }]);
          reject(error);
        });
    });
  },
  [GET_BRANCH_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedBranch = store.getters["enums/branch_enums"];

    if (!forceFetch && cachedBranch?.length > 1) {
      return Promise.resolve(cachedBranch);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      BranchService.search({ active: true, select: "_id,name,arabicName,city" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              city: each?.city,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_BRANCH_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_BRANCH_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_PROVIDER_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedProvider = store.getters["enums/provider_enums"];

    if (!forceFetch && cachedProvider?.length > 1) {
      return Promise.resolve(cachedProvider);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      SupplierService.search({
        active: true,
        select: "_id,name,arabicName,type",
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              type: each.type,
            };
          });
          if (!temp.length)
            temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_PROVIDER_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_PROVIDER_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_FEATURES_ENUMS]({ commit }, { forceFetch = false } = {}) {
      const cachedFeatures = store.getters["enums/features_enums"];

      if (!forceFetch && cachedFeatures?.length > 1) {
        return Promise.resolve(cachedFeatures);
      }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      FeatureService.search({ active: true, select: "_id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_FEATURES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_FEATURES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_LICENSE_TYPE_ENUMS]({ commit }, { forceFetch = false } = {}) {
      const cachedLicenseType = store.getters["enums/license_type_enums"];

      if (!forceFetch && cachedLicenseType?.length > 1) {
        return Promise.resolve(cachedLicenseType);
      }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      LicenseTypeService.search({ active: true, select: "_id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_LICENSE_TYPE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_LICENSE_TYPE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_LANGUAGE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedLanguage = store.getters["enums/language_enums"];

    if (!forceFetch && cachedLanguage?.length > 1) {
      return Promise.resolve(cachedLanguage);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      LanguageService.search({ active: true, select: "_id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              code: each._id,
              name: each.name,
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              code: null,
              name: "select-an-option",
              value: null,
              text: "select-an-option",
            });
          else
            temp.unshift({
              code: null,
              name: "no-options-available",
              value: null,
              text: "no-options-available",
            });
          commit(SET_LANGUAGE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_LANGUAGE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_NATIONALITY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedNationality = store.getters["enums/nationality_enums"];

    if (!forceFetch && cachedNationality?.length > 1) {
      return Promise.resolve(cachedNationality);
    }

    return new Promise((resolve, reject) => {
      NationalityService.search({ active: true })
        .then((items) => {
          const isLangRtl = store.getters["enums/rtlLangs"].includes(
            store.getters["enums/lang"]
          );
          let temp = Object.keys(items)?.map((key) => ({
            code: key,
            name: items[key].name,
            value: key,
            text: isLangRtl ? countries[items[key].name] : items[key].name,
          }));
          if (temp.length)
            temp.unshift({
              code: null,
              name: "select-an-option",
              value: null,
              text: "select-an-option",
            });
          else
            temp.unshift({
              code: null,
              name: "no-options-available",
              value: null,
              text: "no-options-available",
            });
          commit(SET_NATIONALITY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_NATIONALITY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedDriversAvailableNationality = store.getters["enums/drivers_available_nationality_enums"];

    if (!forceFetch && cachedDriversAvailableNationality?.length > 1) {
      return Promise.resolve(cachedDriversAvailableNationality);
    }

    return new Promise((resolve, reject) => {
      NationalityService.get("drivers")
        .then((items) => {
          const isLangRtl = store.getters["enums/rtlLangs"].includes(
            store.getters["enums/lang"]
          );
          let temp = Object.keys(items)?.map((key) => ({
            code: key,
            name: items[key].name,
            value: key,
            text: isLangRtl ? countries[items[key].name] : items[key].name,
          }));
          if (temp.length)
            temp.unshift({
              code: null,
              name: "select-an-option",
              value: null,
              text: "select-an-option",
            });
          else
            temp.unshift({
              code: null,
              name: "no-options-available",
              value: null,
              text: "no-options-available",
            });
          commit(SET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_DRIVER_LIST_ENUMS]({ commit }, query) {
    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = {
        active: true,
        available: true,
        select: "name,arabicName,mobileNumber,available",
      };

      if (query) payload = { ...payload, ...query };

      DriverService.search(payload)
        .then((items) => {
          let temp = items.items?.map((key) => ({
            value: key._id,
            text: isLangRtl ? key.arabicName : key.name || "",
            mobileNumber: key.mobileNumber,
            available: key.available,
          }));
          if (temp.length)
            temp.unshift({
              value: null,
              available: true,
              text: "select-an-option",
            });
          else
            temp.unshift({
              value: null,
              available: true,
              text: "no-options-available",
            });
          commit(SET_DRIVER_LIST_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_DRIVER_LIST_ENUMS, [
            { value: null, available: true, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_ADMINS_ENUMS]({ commit }, query) {
    return new Promise((resolve, reject) => {
      let payload = { select: "key,name" };
      if (query) payload = { ...payload, ...query };
      UserService.search(payload)
        .then((items) => {
          let temp = items.items?.map((key) => ({
            value: key._id,
            text: key.username,
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_ADMINS_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ADMINS_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_SERVICE_TYPE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedServiceType = store.getters["enums/services_type_list_enums"];
  
    if (!forceFetch && cachedServiceType?.length > 1) {
      return Promise.resolve(cachedServiceType);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      ServiceService.search({
        active: true,
        select: "id,name,arabicName,price,vatRate",
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              price: each.price,
              vatRate: each.vatRate,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_SERVICE_TYPE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_SERVICE_TYPE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_ROLES_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedRoles = store.getters["enums/roles_enums"];

    if (!forceFetch && cachedRoles?.length > 1) {
      return Promise.resolve(cachedRoles);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      RolesService.search({ active: true, select: "englishName,arabicName" })
        .then((items) => {
          let temp = items.items?.map((key) => ({
            value: key._id,
            text: isLangRtl ? key.arabicName : key.englishName || "",
          }));
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_ROLES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ROLES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_ACTIVE_ROLES_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedActiveRoles = store.getters["enums/active_roles_enums"];
  
    if (!forceFetch && cachedActiveRoles?.length > 1) {
      return Promise.resolve(cachedActiveRoles);
    }

    return new Promise((resolve, reject) => {
      RolesService.search({
        active: true,
        select: "key,englishName",
        isActive: "true",
      })
        .then((items) => {
          let temp = items.items?.map((key) => ({
            value: key._id,
            text: key.englishName,
          }));
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_ACTIVE_ROLES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ACTIVE_ROLES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CLIENT_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedClients = store.getters["enums/clients_list_enums"];

    if (!forceFetch && cachedClients?.length > 1) {
      return Promise.resolve(cachedClients);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      ClientService.search({
        active: true,
        select:
          "_id,name,arabicName,clientGrade.discountPercentage,hasRetentionPercentage,retentionPercentage,paymentMethod,monthlyInvoice,invoicingUponDelivery"
        })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              clientGrade: {
                discountPercentage: each?.clientGrade?.discountPercentage || 0,
              },
              hasRetentionPercentage: each?.hasRetentionPercentage,
              retentionPercentage: each?.retentionPercentage,
              paymentMethod: each?.paymentMethod,
              monthlyInvoice: each?.monthlyInvoice,
              invoicingUponDelivery: each?.invoicingUponDelivery,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_CLIENT_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CLIENT_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CITY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedCities = store.getters["enums/city_enums"];
  
    if (!forceFetch && cachedCities?.length > 1) {
      return Promise.resolve(cachedCities);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      CityService.search({ active: true, select: "id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_CITY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CITY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_DAMAGE_AREA_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedDamageAreas = store.getters["enums/damage_area_enums"];
  
    if (!forceFetch && cachedDamageAreas?.length > 1) {
      return Promise.resolve(cachedDamageAreas);
    }

    return new Promise((resolve) => {
      commit(SET_DAMAGE_AREA_ENUMS, damage_area_enums);
      resolve(damage_area_enums);
    });
  },
  [GET_BODY_DAMAGE_AREA_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedBodyDamageAreas = store.getters["enums/body_damage_area_enums"];
  
    if (!forceFetch && cachedBodyDamageAreas?.length > 1) {
      return Promise.resolve(cachedBodyDamageAreas);
    }

    return new Promise((resolve) => {
      commit(SET_BODY_DAMAGE_AREA_ENUMS, body_damage_area_enums);
      resolve(body_damage_area_enums);
    });
  },
  [GET_DAMAGE_LEVEL_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedDamageLevel = store.getters["enums/damage_level_enums"];

    if (!forceFetch && cachedDamageLevel?.length > 1) {
    return Promise.resolve(cachedDamageLevel);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      DamageLevelService.search({ active: true, select: "id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select damage level",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_DAMAGE_LEVEL_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_DAMAGE_LEVEL_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_USER_INFO]({ commit }, { forceFetch = false } = {}) {
    const cachedUserInfo = store.getters["enums/user_info"];

    if (!forceFetch && (cachedUserInfo?.userID || cachedUserInfo?.username)) {
      return Promise.resolve(cachedUserInfo);
    }

    return new Promise((resolve, reject) => {
      UserService.get("user-info")
        .then((res) => {
          commit(SET_USER_INFO, res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_CLIENT_INFO]({ commit }) {
    return new Promise((resolve, reject) => {
      ClientService.getDetails()
      invoicingUponDelivery .then((res) => {
          commit(SET_CLIENT_INFO, res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_MISSING_PART_ITEMS]({ commit }) {
    return new Promise((resolve, reject) => {
      VehicleOperationsService.getMissingPartsItems()
        .then((res) => {
          commit(SET_MISSING_PART_ITEMS, res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_COMPANIES_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedCompanies = store.getters["enums/companies_enums"];

    if (!forceFetch && cachedCompanies?.length > 1) {
    return Promise.resolve(cachedCompanies);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      companyProfile.search({ active: true, select: "_id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_COMPANIES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_COMPANIES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_INSURANCE_COMPANY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedInsuranceCompany = store.getters["enums/insurance_company_enums"];

    if (!forceFetch && cachedInsuranceCompany?.length > 1) {
      return Promise.resolve(cachedInsuranceCompany);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      InsuranceCompanyService.search({
        active: true,
        select: "id,name,arabicName",
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_INSURANCE_COMPANY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_INSURANCE_COMPANY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_REGIONS_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedRegions = store.getters["enums/regions_enums"];

    if (!forceFetch && cachedRegions?.length > 1) {
      return Promise.resolve(cachedRegions);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      RegionService.search({ active: true, select: "id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select a Region",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_REGIONS_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_REGIONS_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_PROVINCES_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedProvinces = store.getters["enums/provinces_enums"];

    if (!forceFetch && cachedProvinces?.length > 1) {
      return Promise.resolve(cachedProvinces);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      ProvinceService.search({ active: true, select: "id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_PROVINCES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_PROVINCES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_ZONE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedZones = store.getters["enums/zone_enums"];

    if (!forceFetch && cachedZones?.length > 1) {
      return Promise.resolve(cachedZones);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      ZoneService.search({
        active: true,
        select: "id,name,arabicName,branch.name",
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              branch: each.branch.id,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_ZONE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ZONE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_POS_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedPOS = store.getters["enums/pos_enums"];

    if (!forceFetch && cachedPOS?.length > 1) {
      return Promise.resolve(cachedPOS);
    }

    return new Promise((resolve, reject) => {
      POSDeviceService.search({
        active: true,
        select: "id,brand,model,driver,barcode",
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each.brand + " " + each.model,
              driver: each.driver,
              barcode: each.barcode,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_POS_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_POS_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_MOBILE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedMobiles = store.getters["enums/mobile_enums"];

    if (!forceFetch && cachedMobiles?.length > 1) {
      return Promise.resolve(cachedMobiles);
    }

    return new Promise((resolve, reject) => {
      MobileDeviceService.search({
        active: true,
        select: "id,brand,model,driver,barcode",
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each.brand + " " + each.model,
              driver: each.driver,
              barcode: each.barcode,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_MOBILE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_MOBILE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_SERVICES_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedServices = store.getters["enums/services_enums"];
    
    if (!forceFetch && cachedServices?.length > 1) {
      return Promise.resolve(cachedServices);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      ServiceService.search({
        active: true,
        select:
          "id,name,arabicName,price,vatRate,taxType.percentage,category.name,type",
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              name: each.name,
              arabicName: each.arabicName,
              text: isLangRtl ? each.arabicName : each.name || "",
              price: each.price,
              vatRate: each.taxType.reduce((acc, item) => acc + item.percentage, 0),
              category: each.category?.name,
              type: each.type,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_SERVICES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_SERVICES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_DRIVER_AVAILABILITY]({ commit }) {
    return new Promise((resolve, reject) => {
      const thisDay = new Date();
      const thisDayISO = thisDay.toISOString().substring(0, 10);

      const data = {
        date: thisDayISO,
        unassignedVehicles: true,
      };

      DriverService.get("availability", data)
        .then((res) => {
          commit(SET_DRIVER_AVAILABILITY, res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_VEHICLE_AVAILABILITY]({ commit }) {
    return new Promise((resolve, reject) => {
      const thisDay = new Date();
      const thisDayISO = thisDay.toISOString().substring(0, 10);

      const data = {
        date: thisDayISO,
      };

      VehicleService.get("availability", data)
        .then((res) => {
          commit(SET_VEHICLE_AVAILABILITY, res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_PROMO_CODE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedPromoCodes = store.getters["enums/promo_code_enums"];

    if (!forceFetch && cachedPromoCodes?.length > 1) {
      return Promise.resolve(cachedPromoCodes);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      PromoCodeService.search({ active: true, select: "id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_PROMO_CODE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_PROMO_CODE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_LTA_LIST_ENUMS]({ commit }, selectedClient) {
    return new Promise((resolve, reject) => {
      let params = {
        active: true,
        select: "id,termsEnglish,services",
      };

      if (selectedClient) params["client"] = selectedClient;

      LongTermsAgreementService.search(params)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each._id,
              outstandingBalance: each?.services.reduce(
                (acc, each) => acc + each?.outstandingBalance,
                0
              ),
              nonInvoicedAmount: each?.services.reduce(
                (acc, each) => acc + each?.nonInvoicedAmount,
                0
              ),
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_LTA_LIST_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_LTA_LIST_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CLIENT_TYPE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedClientType = store.getters["enums/clientType_enums"];

    if (!forceFetch && cachedClientType?.length > 1) {
      return Promise.resolve(cachedClientType);
    }

    return new Promise((resolve) => {
      commit(SET_CLIENT_TYPE_ENUMS, clientType_enums);
      resolve(clientType_enums);
    });
  },
  [GET_ACCOUNT_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedAccounts = store.getters["enums/account_enums"];

    if (!forceFetch && cachedAccounts?.length > 1) {
      return Promise.resolve(cachedAccounts);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      AccountService.search({
        active: true,
        select: "id,name,arabicName",
        isMain: false,
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select account",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_ACCOUNT_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ACCOUNT_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_PROFORMA_INVOICE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedProformaInvoices = store.getters["enums/proforma_invoice_enums"];

    if (!forceFetch && cachedProformaInvoices?.length > 1) {
      return Promise.resolve(cachedProformaInvoices);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      ProformaInvoiceService.search({
        active: true,
        select: "id,name,arabicName",
      })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select proforma invoice",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_PROFORMA_INVOICE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_PROFORMA_INVOICE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_JV_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedJVs = store.getters["enums/JV_enums"];

    if (!forceFetch && cachedJVs?.length > 1) {
      return Promise.resolve(cachedJVs);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      JVService.search({ active: true, select: "id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select journal voucher",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_JV_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_JV_ENUMS, [{ value: null, text: "no-options-available" }]);
          reject(error);
        });
    });
  },
  [GET_RESERVATION_LIST_ENUMS]({ commit }, selectedClient) {
    return new Promise((resolve, reject) => {
      let params = {
        active: true,
        select: "id,nonInvoicedAmount",
        type:"ne:Contract"        
      };

      if (selectedClient) params["client"] = selectedClient;

      NewReservationService.search(params)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each._id,
              nonInvoicedAmount: each.nonInvoicedAmount,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select reservation",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_RESERVATION_LIST_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_RESERVATION_LIST_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_REMOTE_FINANCE_ACCOUNT_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedRemoteFinanceAccounts = store.getters["enums/remote_finance_account_enums"];

    if (!forceFetch && cachedRemoteFinanceAccounts?.length > 1) {
      return Promise.resolve(cachedRemoteFinanceAccounts);
    }

    return new Promise((resolve, reject) => {
      AccountService.get("remote-finance-account", {
        active: true,
        select: "id,account_name",
      })
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each.account_name,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select account",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_REMOTE_FINANCE_ACCOUNT_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_REMOTE_FINANCE_ACCOUNT_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_TAX_TYPE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedTaxTypes = store.getters["enums/tax_type_enums"];

    if (!forceFetch && cachedTaxTypes?.length > 1) {
      return Promise.resolve(cachedTaxTypes);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      TaxTypeService.search({ active: true, select: "id,name,arabicName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select tax type",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_TAX_TYPE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_TAX_TYPE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_TAX_TYPE_ZOHO_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedTaxTypesZoho = store.getters["enums/tax_type_zoho_enums"];

    if (!forceFetch && cachedTaxTypesZoho?.length > 1) {
      return Promise.resolve(cachedTaxTypesZoho);
    }

    return new Promise((resolve, reject) => {
      TaxTypeService.get("remote-taxes")
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each.tax_id,
              text: `${each.tax_name} [${each.tax_percentage}%]`,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select account",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_TAX_TYPE_ZOHO_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_TAX_TYPE_ZOHO_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_OPERATOR]({ commit }, operator) {
    return new Promise((resolve) => {
      commit(SET_OPERATOR, operator);
      resolve(operator);
    });
  },
  [GET_TRAINING_TYPES_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedTrainingTypes = store.getters["enums/training_type_enums"];

    if (!forceFetch && cachedTrainingTypes?.length > 1) {
      return Promise.resolve(cachedTrainingTypes);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = { select: "id,name,arabicName" };

      TrainingTypeService.search(payload)
        .then((items) => {
          let temp = items.items?.map((each) => ({
            value: each._id,
            text: isLangRtl ? each.arabicName : each.name || "",
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_TRAINING_TYPES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_TRAINING_TYPES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_TAX_TYPE_ODOO_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedTaxTypesODOO = store.getters["enums/tax_type_odoo_enums"];

    if (!forceFetch && cachedTaxTypesODOO?.length > 1) {
      return Promise.resolve(cachedTaxTypesODOO);
    }

    return new Promise((resolve, reject) => {
      TaxTypeService.get("odoo-remote-taxes")
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each.tax_id,
              text: `${each.tax_name} [${each.tax_percentage}%]`,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select account",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_TAX_TYPE_ODOO_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_TAX_TYPE_ODOO_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedODOORemoteFinanceAccounts = store.getters["enums/odoo_remote_finance_account_enums"];

    if (!forceFetch && cachedODOORemoteFinanceAccounts?.length > 1) {
      return Promise.resolve(cachedODOORemoteFinanceAccounts);
    }

    return new Promise((resolve, reject) => {
      AccountService.get("odoo-remote-finance-account", {
        active: true,
        select: "_id,name",
      })
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each.name,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select account",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_PRODUCT_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedProducts = store.getters["enums/product_enums"];

    if (!forceFetch && cachedProducts?.length > 1) {
      return Promise.resolve(cachedProducts);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = {
        select: "_id,name,arabicName,services",
      };

      ProductService.search(payload)
        .then((items) => {
          let temp = items.items?.map((each) => ({
            value: each._id,
            name: each.name,
            arabicName: each.arabicName,
            text: isLangRtl ? each.arabicName : each.name || "",
            services: each.services.length,
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_PRODUCT_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_PRODUCT_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_PRICING_LISTS_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedPricingLists = store.getters["enums/pricing_lists_enums"];
    
    if (!forceFetch && cachedPricingLists?.length > 1) {
      return Promise.resolve(cachedPricingLists);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = {
        select: "_id,name,arabicName",
      };

      PricingListService.search(payload)
        .then((items) => {
          let temp = items.items?.map((each) => ({
            value: each._id,
            text: (isLangRtl ? each.arabicName : each.name) || "",
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_PRICING_LISTS_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_PRICING_LISTS_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_HAJJ_SEASON_YEAR_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedHajjSeasons = store.getters["enums/hajj_season_year_enums"];

    if (!forceFetch && cachedHajjSeasons?.length > 1) {
      return Promise.resolve(cachedHajjSeasons);
    }

    return new Promise((resolve, reject) => {
      HajjSeasonYearService.get("ddl")
        .then((res) => {
          let temp = (res?.items || []).map((each) => ({
            value: each.value,
            text: each.text,
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_HAJJ_SEASON_YEAR_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_HAJJ_SEASON_YEAR_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_TGA_TYPES_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedTGATypes = store.getters["enums/tga_type_enums"];

    if (!forceFetch && cachedTGATypes?.length > 1) {
      return Promise.resolve(cachedTGATypes);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = { select: "id,name,arabicName" };

      TGATypeService.search(payload)
        .then((items) => {
          let temp = items.items?.map((each) => ({
            value: each._id,
            text: isLangRtl ? each.arabicName : each.name || "",
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_TGA_TYPES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_TGA_TYPES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_RELIGION_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedReligions = store.getters["enums/religion_enums"];

    if (!forceFetch && cachedReligions?.length > 1) {
      return Promise.resolve(cachedReligions);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = { select: "id,name,arabicName" };

      ReligionService.search(payload)
        .then((items) => {
          let temp = items.items?.map((each) => ({
            value: each._id,
            text: isLangRtl ? each.arabicName : each.name || "",
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_RELIGION_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_RELIGION_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CLIENT_GRADE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedClientGrades = store.getters["enums/client_grade_enums"];

    if (!forceFetch && cachedClientGrades?.length > 1) {
      return Promise.resolve(cachedClientGrades);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = { select: "id,name,arabicName" };

      ClientGradeService.search(payload)
        .then((items) => {
          let temp = items.items?.map((each) => ({
            value: each._id,
            text: isLangRtl ? each.arabicName : each.name || "",
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_CLIENT_GRADE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CLIENT_GRADE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_RESERVATION_CATEGORY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedReservationCategories = store.getters["enums/reservation_category_enums"];

    if (!forceFetch && cachedReservationCategories?.length > 1) {
      return Promise.resolve(cachedReservationCategories);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = { select: "id,name,arabicName,type" };

      ReservationCategoryService.search(payload)
        .then(({ result }) => {
          let temp = result.items?.map((each) => ({
            value: each._id,
            text: isLangRtl ? each.arabicName : each.name || "",
            type: each.type,
          }));
          if (temp.length)
            temp.unshift({ value: null, text: "select-an-option" });
          else temp.unshift({ value: null, name: "no-options-available" });
          commit(SET_RESERVATION_CATEGORY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_RESERVATION_CATEGORY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_SERVICE_CATEGORY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedServiceCategories = store.getters["enums/service_category_enums"];

    if (!forceFetch && cachedServiceCategories?.length > 1) {
      return Promise.resolve(cachedServiceCategories);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      ServiceCategory.search({ select: "id,name,arabicName" })
        .then(({ result }) => {
          let temp = result.items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_SERVICE_CATEGORY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_SERVICE_CATEGORY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CONTRACT_TYPE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedContractTypes = store.getters["enums/contract_type_enums"];

    if (!forceFetch && cachedContractTypes?.length > 1) {
      return Promise.resolve(cachedContractTypes);
    }
  
    return new Promise((resolve) => {
      commit(SET_CONTRACT_TYPE_ENUMS, contractType_enums);
      resolve(contractType_enums);
    });
  },
  [GET_DRIVER_USERNAME_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedDriverUsernames = store.getters["enums/driver_username_enums"];

    if (!forceFetch && cachedDriverUsernames?.length > 1) {
      return Promise.resolve(cachedDriverUsernames);
    }

    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      params.append("sort", "-updated_on");
      params.append("select", "username");

      DriverService.search(params)
        .then((result) => {
          let temp = result.items?.map((each) => {
            return {
              value: each.username,
              text: each.username,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_DRIVER_USERNAME_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_DRIVER_USERNAME_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CLIENT_USERNAME_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedClientUsernames = store.getters["enums/client_username_enums"];

    if (!forceFetch && cachedClientUsernames?.length > 1) {
      return Promise.resolve(cachedClientUsernames);
    }
  
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      params.append("sort", "-updated_on");
      params.append("select", "username");

      ClientService.search(params)
        .then((result) => {
          let temp = result.items?.map((each) => {
            return {
              value: each.username,
              text: each.username,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_CLIENT_USERNAME_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CLIENT_USERNAME_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_RESOURCE_REQUEST_USERNAME_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedResourceRequestUsernames = store.getters["enums/resource_request_username_enums"];

    if (!forceFetch && cachedResourceRequestUsernames?.length > 1) {
      return Promise.resolve(cachedResourceRequestUsernames);
    }

    return new Promise((resolve, reject) => {
      TemporaryResourcesRequestService.get("usernames")
        .then(({ result }) => {
          let temp = result?.map((each) => {
            return {
              value: each,
              text: each,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_RESOURCE_REQUEST_USERNAME_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_RESOURCE_REQUEST_USERNAME_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_USER_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedUsers = store.getters["enums/user_enums"];

    if (!forceFetch && cachedUsers?.length > 1) {
      return Promise.resolve(cachedUsers);
    }
  
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      params.append("sort", "-updated_on");
      params.append("select", "username");

      UserService.search(params)
        .then((result) => {
          let temp = result.items?.map((each) => {
            return {
              value: each._id,
              text: each.username,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_USER_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_USER_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_RESERVATION_FILE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      NewReservationService.downloadReservations(params)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/octet-stream",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `reservations-${moment()
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY")}.xlsx`
          );
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_TRIPS_FILE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      TripService.downloadTrips(params)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/octet-stream",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `trips-${moment()
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY")}.xlsx`
          );
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [SET_MISSING_REQUEST_PAYLOAD_IN_STORE]({ commit }, payload) {
    return new Promise((resolve) => {
      commit(SET_MISSING_REQUEST_PAYLOAD, payload);
      resolve(payload);
    });
  },
  [GET_VEHICLE_TYPE_ENUMS]({ commit }, { forceFetch = false } = {}) {
      const cachedVehicleType = store.getters["enums/vehicle_type_enums"];

      if (!forceFetch && cachedVehicleType?.length > 1) {
        return Promise.resolve(cachedVehicleType);
      }

    let payload = { select: "_id,name,model,model.numberOfSeats,numberOfSeats,capacity,maxSeatsPerVehicle" };
    return new Promise((resolve, reject) => {
      VehicleTypeService.search(payload)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each?._id,
              text: each?.name,
              model: each?.model,
              numberOfSeats:
                each?.numberOfSeats ||
                each?.model?.numberOfSeats ||
                each?.capacity ||
                each?.maxSeatsPerVehicle ||
                null,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_VEHICLE_TYPE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_VEHICLE_TYPE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_BLANKET_ORDER_ENUMS]({ commit }, query) {
    let payload = { select: "_id,client", status: "confirmed" };
    if (query) payload = { ...payload, ...query };
    return new Promise((resolve, reject) => {
      BlanketOrderService.search(payload)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each?._id,
              text: each?._id,
              client: each?.client,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_BLANKET_ORDER_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_BLANKET_ORDER_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_KPI_REASON_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedKPIReasons = store.getters["enums/kpi_reason_enums"];

    if (!forceFetch && cachedKPIReasons?.length > 1) {
      return Promise.resolve(cachedKPIReasons);
    }
  
    return new Promise((resolve, reject) => {
      NewReservationService.get("kpi-reason")
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each?._id,
              text: each?.name,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_KPI_REASON_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_KPI_REASON_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CLIENT_CITY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedClientCities = store.getters["enums/client_city_enums"];

    if (!forceFetch && cachedClientCities?.length > 1) {
      return Promise.resolve(cachedClientCities);
    }

    return new Promise((resolve, reject) => {
      ClientCityService.search()
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each.name,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_CLIENT_CITY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CLIENT_CITY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CLIENT_COUNTRY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedClientCountries = store.getters["enums/client_country_enums"];

    if (!forceFetch && cachedClientCountries?.length > 1) {
      return Promise.resolve(cachedClientCountries);
    }
  
    return new Promise((resolve, reject) => {
      ClientCountryService.search()
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each.name,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_CLIENT_COUNTRY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CLIENT_COUNTRY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [SHOW_TOASTER_POP]({ commit }, obj) {
    commit(SET_TOASTER_POP, obj);
  },
  [GET_CHANGE_PASSWORD_TOKEN]({ commit }, obj) {
    commit(SET_CHANGE_PASSWORD_TOKEN, obj);
  },
  [GET_AVAILABLE_RESERVATION_LIST_ENUMS]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const { status, filter, selectedClient } = payload || {};

      const params = {
        active: true,
        select: "id,nonInvoicedAmount",
        type:"ne:Contract",
        status: "nin:[cancelled,draft-quotation,draft-sales-order,waiting-for-approval]",
        ...(status && { status: "in:[" + status + "]" }),
        ...(filter && { status: "nin:[" + filter + "]" }),
        ...(selectedClient && { client: selectedClient })
      };
      NewReservationService.search(params)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each._id,
              nonInvoicedAmount: each.nonInvoicedAmount,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select reservation",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_AVAILABLE_RESERVATION_LIST_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_AVAILABLE_RESERVATION_LIST_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CHANGE_PASSWORD_TOKEN]({ commit }, obj) {
    commit(SET_CHANGE_PASSWORD_TOKEN, obj);
  },
  [GET_SHIFT_TYPE_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedShiftTypes = store.getters["enums/shift_type_enums"];

    if (!forceFetch && cachedShiftTypes?.length > 1) {
      return Promise.resolve(cachedShiftTypes);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      ShiftService.search({ select: "_id,name,arabicName,shiftTimes" })
        .then(({ items }) => {
          // Function to get firstShiftStartTime and lastShiftEndTime
          const getShiftTimes = (shiftTimes) => {
            if (!shiftTimes || !shiftTimes.length) return { firstShiftStartTime: null, lastShiftEndTime: null };

            // Convert time strings to Date objects and sort them
            const toDate = (timeString) => new Date(`1970-01-01T${timeString}Z`);
            const sortedShiftTimes = shiftTimes.sort((a, b) => toDate(a.startTime) - toDate(b.startTime));

            const firstShiftStartTime = sortedShiftTimes[0].startTime;
            const lastShiftEndTime = sortedShiftTimes[sortedShiftTimes.length - 1].endTime;

            return { firstShiftStartTime, lastShiftEndTime };
          };
          let temp = items?.map((each) => {
            const { firstShiftStartTime, lastShiftEndTime } = getShiftTimes(each.shiftTimes);
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
              firstShiftStartTime,
              lastShiftEndTime,
              shiftTimes: each.shiftTimes,
            };
          });
          if (temp.length) {
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          } else {
            temp.unshift({ value: null, text: "no-options-available" });
          }
          commit(SET_SHIFT_TYPE_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_SHIFT_TYPE_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CONTRACT_ID_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedContractNames = store.getters["enums/contract_id_enums"];

    if (!forceFetch && cachedContractNames?.length > 1) {
      return Promise.resolve(cachedContractNames);
    }
    const params ={
      select: "_id" 
    }
    return new Promise((resolve, reject) => {
      ContractService.search(params)
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each._id,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_CONTRACT_ID_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CONTRACT_ID_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },

  [GET_CONTRACT_ID_CLIENT_ENUMS]({ commit }, { clientID, statuses }) {
    const params = {
      active: true,
      status: "in:[" + statuses + "]",
      select: "_id,nonInvoicedAmount",
      client: clientID,
    }
    return new Promise((resolve, reject) => {
      ContractService.get("all", params)
        .then(({items}) => {
          let temp = items?.map((each) => {
            return {
              value: each?._id,
              text: each?._id,
              nonInvoicedAmount: each?.nonInvoicedAmount,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_CONTRACT_ID_CLIENT_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_CONTRACT_ID_CLIENT_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_DRIVER_EMPLOYEE_ID_ENUMS]({ commit }, query) {
    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = {
        active: true,
        available: true,
        select: "name,arabicName,mobileNumber,available,employeeID",
      };

      if (query) payload = { ...payload, ...query };
      DriverService.search(payload)
        .then((items) => {
          let temp = items.items?.map((key) => ({
            value: key._id,
            text: key.employeeID,
            mobileNumber: key.mobileNumber,
            available: key.available,
          }));
          if (temp.length)
            temp.unshift({
              value: null,
              available: true,
              text: "select-an-option",
            });
          else
            temp.unshift({
              value: null,
              available: true,
              text: "no-options-available",
            });
          commit(SET_DRIVER_EMPLOYEE_ID, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_DRIVER_EMPLOYEE_ID, [
            { value: null, available: true, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_PAYMENT_TYPES_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedPaymentTypes = store.getters["enums/payment_method_enums"];

    if (!forceFetch && cachedPaymentTypes?.length > 1) {
      return Promise.resolve(cachedPaymentTypes);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      PaymentMethodService.search()
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_PAYMENT_TYPES, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_PAYMENT_TYPES, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_CLIENT_CONTACT_PERSON_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedClientContactPersons = store.getters["enums/client_contact_person_enums"];

    if (!forceFetch && cachedClientContactPersons?.length > 1) {
      return Promise.resolve(cachedClientContactPersons);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      let payload = { select: "_id,contactPerson" };

      ClientService.search(payload)
      .then(({ items }) => {
        let temp = items
          ?.flatMap((each) => {
            if (Array.isArray(each.contactPerson) && each.contactPerson.length > 0) {
              return each.contactPerson.map((contact) => ({
                value: contact?._id,
                text: isLangRtl ? contact?.arabicName : contact?.name,
                client: each._id,
              }));
            }
            return [];
          })
          .filter((contact) => contact.value && contact.text);
        if (temp?.length) {
          temp.unshift({ value: null, text: "select-an-option" });
        } else {
          temp = [{ value: null, text: "no-options-available" }];
        }
        commit(SET_CLIENT_CONTACT_PERSON_ENUMS, temp);
        resolve(temp);
      })
      .catch((error) => {
        commit(SET_CLIENT_CONTACT_PERSON_ENUMS, [
          { value: null, text: "no-options-available" },
        ]);
        reject(error);
      });
    });
  },
  [GET_ENTITY_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedEntities = store.getters["enums/entity_enums"];

    if (!forceFetch && cachedEntities?.length > 1) {
      return Promise.resolve(cachedEntities);
    }

    return new Promise((resolve, reject) => {
      HistoryService.get("available-entities")
        .then((items) => {
          let temp = items?.map((each) => {
            return {
              value: each || "",
              text: each || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_ENTITY_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ENTITY_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_USERNAME_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedUsernames = store.getters["enums/username_enums"];

    if (!forceFetch && cachedUsernames?.length > 1) {
      return Promise.resolve(cachedUsernames);
    }

    return new Promise((resolve, reject) => {
      UserService.search({ select: "_id,username" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each.username || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_USERNAME_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_USERNAME_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_ADMIN_CONFIGURATION_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedConfiguration = store.getters["enums/admin_configuration_enums"];

    if (!forceFetch && cachedConfiguration?.length > 1) {
      return Promise.resolve(cachedConfiguration);
    }

    return new Promise((resolve, reject) => {
      AdminConfigurationService.get("1")
        .then((res) => {
          let temp = {};
          if (res) {
            temp = res;
          }
          commit(SET_ADMIN_CONFIGURATION_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ADMIN_CONFIGURATION_ENUMS, {});
          reject(error);
        });
    });
  },
  [GET_DRIVER_ALLOWANCE_FILE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      DriverAllowanceService.exportDriverAllowance(params)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/octet-stream",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `driver-allowance-${moment()
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY")}.xlsx`
          );
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_HAJJ_DAWRA_OPERATIONS_FILE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      HajjDawraOperationService.exportDawraOperations(params)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/octet-stream",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `hajj-dawra-operations-${moment()
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY")}.xlsx`
          );
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_DRIVER_EMP_ID_ENUMS]({ commit }, {forceFetch = false} = {}) {
    const cachedDriverEmpId = store.getters["enums/driver_employee_id_enums"];
    
    if (!forceFetch && cachedDriverEmpId?.length > 1) {
      return Promise.resolve(cachedDriverEmpId);
    }

    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      params.append("sort", "-updated_on");
      params.append("select", "_id,employeeID");

      DriverService.search(params)
        .then((result) => {
          let temp = result.items?.map((each) => {
            return {
              value: each._id,
              text: each.employeeID,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_DRIVER_EMP_ID_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_DRIVER_EMP_ID_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_PRICING_LIST_FILE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      PricingListService.exportPricinglist(params)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/octet-stream",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `pricing-list-${moment()
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY")}.xlsx`
          );
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_ROUTES_LIST_ENUMS]({ commit }, payload) {
    const isLangRtl = store.getters["enums/rtlLangs"].includes(
      store.getters["enums/lang"]
    );
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      params.append("sort", "-updated_on");
      params.append("contract", payload?.id);
      params.append("select", "_id,name,arabicName");
      ContractRouteService.get("all", params)
        .then((result) => {
          let temp = result.items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.name,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_ROUTES_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_ROUTES_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_TRIPS_CONTRACT_FILE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      TripService.downloadTripsContracts(params)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res], {
              type: "application/octet-stream",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `trips-${moment()
              .locale("en")
              .utcOffset(0)
              .format("DD-MM-YYYY")}.xlsx`
          );
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [GET_WORKFLOW_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedWorkflows = store.getters["enums/workflow_enums"];

    if (!forceFetch && cachedWorkflows?.length > 1) {
      return Promise.resolve(cachedWorkflows);
    }

    return new Promise((resolve, reject) => {
      const isLangRtl = store.getters["enums/rtlLangs"].includes(
        store.getters["enums/lang"]
      );
      WorkFlowService.search({ active: true, select: "_id,arabicName,englishName" })
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: isLangRtl ? each.arabicName : each.englishName || "",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select a workflow",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_WORKFLOW_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_WORKFLOW_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
  [GET_PROFORMA_INVOICE_NUMBER_ENUMS]({ commit }, { client } = {}) {

    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      params.append("active", true);
      params.append("select", "id,remainingAmount");
      params.append("client", client)
      params.append("remainingAmount", "gt:0");
      ProformaInvoiceService.search(params)
        .then(({ items }) => {
          let temp = items?.map((each) => {
            return {
              value: each._id,
              text: each._id,
              remainingAmount: each.remainingAmount || null,
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "Select proforma invoice",
              remainingAmount: null
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_PROFORMA_INVOICE_NUMBER_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_PROFORMA_INVOICE_NUMBER_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
    [GET_USER_NAME_ENUMS]({ commit }, { forceFetch = false } = {}) {
    const cachedUsers = store.getters["enums/user_name_enums"];

    if (!forceFetch && cachedUsers?.length > 1) {
      return Promise.resolve(cachedUsers);
    }
  
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      params.append("sort", "-updated_on");
      params.append("select", "name");

      UserService.search(params)
        .then((result) => {
          let temp = result.items?.map((each) => {
            return {
              value: each._id,
              text: each.name || "---",
            };
          });
          if (temp.length)
            temp.unshift({
              value: null,
              text: "select-an-option",
            });
          else temp.unshift({ value: null, text: "no-options-available" });
          commit(SET_USER_NAME_ENUMS, temp);
          resolve(temp);
        })
        .catch((error) => {
          commit(SET_USER_NAME_ENUMS, [
            { value: null, text: "no-options-available" },
          ]);
          reject(error);
        });
    });
  },
};
